import {Pane, PaneGroupConfig} from "./pane";
import {SecondaryPaneComponent} from "../components/secondary_pane_component";
import {getElementByElementOrId} from "../../../helpers/element";
import {
    ExperiencePaneOptionComponent,
    ExperiencePaneOptionComponentConfig
} from "../components/experience_pane_option_component";

export class SecondaryPane extends Pane {

    static new(element, secondaryPanesManager) {
        if (!element) {
            return null
        }
        return new SecondaryPane(element, secondaryPanesManager)
    }

    constructor(id_or_element, secondaryPanesManager) {
        super(id_or_element);
        this.group = PaneGroupConfig.secondaryGroupCode;
        const element = getElementByElementOrId(id_or_element);
        this.paneComponent = new SecondaryPaneComponent(element, this);
        this.secondaryPanesManager = secondaryPanesManager;

        this.onBeforeFocusCallbacks.push(this.attach.bind(this));
        this.onAfterBlurCallbacks.push(this.detach.bind(this));

        // Only a focused pane counts impressions: stop observing before blur (a blurred pane stays laid
        // out for ~1s while it slides out) and start again after focus. Mirrors PrimaryPane.
        this.onBeforeBlurCallbacks.push(this.stopObservingPaneOptionViews.bind(this));
        this.onAfterFocusCallbacks.push(this.startObservingPaneOptionViews.bind(this));

        this.experiencePaneOptionComponents = getExperiencePaneOptionComponents(this);
    }

    getNav() {
        let panesManager = this.getPanesManager();
        return panesManager.nav;
    }

    getPanesManager() {
        if (!this.secondaryPanesManager) return;
        return this.secondaryPanesManager.panesManager;
    }

    trackOpened() {
        let nav = this.getNav();
        if (nav && nav.rankersAnalyticsEventTracker && window.RankersAnalytics) {
            const backwardsCompatibilityOptions = {eventLabel: this.statsIdentifier}; // See tracker.js `getBackwardsCompatibilityParams()` function to understand this!
            const options = {nav_pane_id: this.statsIdentifier};
            nav.rankersAnalyticsEventTracker(window.RankersAnalytics.EventName.NAV_PANE_OPENED, {...backwardsCompatibilityOptions, ...options});
        }
    }

    close() {
        this.secondaryPanesManager.closePanes();
    }

    // Stop observing the experiencePaneOptionComponents for stats impressions (views).
    stopObservingPaneOptionViews() {
        this.experiencePaneOptionComponents.forEach((experiencePaneOptionComponent) => {
            experiencePaneOptionComponent.unobserveViewed();
        });
    }

    // Start observing the experiencePaneOptionComponents for stats impressions (views).
    startObservingPaneOptionViews() {
        this.experiencePaneOptionComponents.forEach((experiencePaneOptionComponent) => {
            experiencePaneOptionComponent.observeViewed();
        });
    }

    // Count impressions withheld while the nav was shut (see `Nav#flushPendingImpressions`).
    flushPendingPaneOptionViews() {
        this.experiencePaneOptionComponents.forEach((experiencePaneOptionComponent) => {
            experiencePaneOptionComponent.flushPendingViewed();
        });
    }

}

function getExperiencePaneOptionComponents(secondaryPane) {
    let experiencePaneOptionComponents = [];
    const paneOptionElements = secondaryPane.element.querySelectorAll(ExperiencePaneOptionComponentConfig.selector);
    paneOptionElements.forEach((element) => {
        let component = new ExperiencePaneOptionComponent(element, secondaryPane, secondaryPane.secondaryPanesManager);
        experiencePaneOptionComponents.push(component);
    });
    return experiencePaneOptionComponents;
}
